if (__IS_LEGACY__) {
  require('core-js/stable')
}

// Loads the polyfill for custom elements for non-legacy browsers that need it (Edge)
if ('customElements' in window === false) {
  import('@webcomponents/custom-elements').then(() => require('./client'))
} else {
  require('./client')
}
